import React from 'react';
import { Lock, ShieldCheck, Zap, Clock } from 'lucide-react';
import { PremiumCTAButton } from './ui/PremiumCTAButton';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-black relative overflow-hidden" data-id="element-197">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[120px]" data-id="element-198"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-199">
        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-200">
          Si tu estrés viene de tener <br data-id="element-201" />
          <span className="text-gradient-gold" data-id="element-202">demasiado abierto...</span>
        </h2>

        <p className="text-2xl text-gray-300 mb-8" data-id="element-203">
          No necesitas más horas.{' '}
          <span className="text-white font-semibold" data-id="element-204">Necesitas cerrar.</span>
        </p>

        <div className="bg-dark-900 border border-gold-500/20 rounded-2xl p-8 mb-10 max-w-2xl mx-auto" data-id="element-205">
          <p className="text-3xl font-serif text-gold-500 mb-2" data-id="element-206">Un bloque.</p>
          <p className="text-3xl font-serif text-gold-500 mb-2" data-id="element-207">Una tarea.</p>
          <p className="text-3xl font-serif text-gold-500 mb-4" data-id="element-208">Un cierre.</p>
          <p className="text-lg text-gray-400" data-id="element-209">
            Hazlo visible. Y el ruido baja.
          </p>
        </div>

        <motion.div className="mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-210">
          <motion.div className="inline-flex items-center gap-3 bg-gradient-to-r from-red-600 to-orange-600 text-white px-6 py-3 rounded-full border-2 border-red-400/50 shadow-xl" animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-211">
            <Clock className="w-5 h-5 animate-pulse" data-id="element-212" />
            <span className="font-bold text-base md:text-lg uppercase tracking-wider" data-id="element-213">
              ⏰ Oferta por Tiempo Limitado
            </span>
            <Clock className="w-5 h-5 animate-pulse" data-id="element-214" />
          </motion.div>
        </motion.div>

        <div className="flex flex-col items-center gap-6" data-id="element-215">
          <PremiumCTAButton size="xl" className="w-full md:w-auto" data-id="element-216" />

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mt-4" data-id="element-217">
            <div className="flex items-center gap-2" data-id="element-218">
              <Lock className="w-4 h-4 text-gold-500" data-id="element-219" />
              <span data-id="element-220">Pago Seguro SSL</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-221">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-222" />
              <span data-id="element-223">Garantía de 30 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-224">
              <Zap className="w-4 h-4 text-gold-500" data-id="element-225" />
              <span data-id="element-226">Acceso Instantáneo</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}